import React, { useContext } from 'react'
import {
    StyledBoldFont,
    StyledPanelButtonContainer,
    StyledPanelSaveSearchButton,
    StyledSaveSearchVerificationModalText,
    StyledSaveSearchVerificationModalTitle,
    StyledSaveSearchVerificationModalWrapper,
} from './save-search-form.styles'
import { Alert } from '../../../__generated__/fed-graphql-types'
import { useEmailVerification } from '../../../hooks/saved-search/use-email-verified'
import { SavedSearchQueryContext } from '../../../contexts/saved-search-context'

interface CheckYourInboxProps {
    saveSearch: (name: string, searchUrl: string, alert: Alert, message?: string) => Promise<void>
    searchName: string
    alert: Alert
}

export const CheckYourInboxComponent = ({ saveSearch, searchName, alert }: CheckYourInboxProps) => {
    const { loading, userEmailVerificationRefetch } = useEmailVerification()
    const { savedSearchPersonalData } = useContext(SavedSearchQueryContext)
    const searchUrl = window.location.pathname + window.location.search

    if (loading) {
        return <h1>loading...</h1>
    }
    const onOKGotItClick = async () => {
        userEmailVerificationRefetch()
            .then((value) => {
                if (!!value.data.user?.emailVerified) {
                    saveSearch(searchName, searchUrl, alert)
                } else {
                    saveSearch(searchName, searchUrl, Alert.OFF, 'Search saved, alerts not set.')
                }
            })
            .catch((error) => {
                console.log(error.message)
                saveSearch(searchName, searchUrl, Alert.OFF, 'Search saved, alerts not set.')
            })
    }

    return (
        <StyledSaveSearchVerificationModalWrapper data-testid="saved-search-modal">
            <>
                <StyledSaveSearchVerificationModalTitle as="h3">
                    Check your inbox
                </StyledSaveSearchVerificationModalTitle>
                <StyledSaveSearchVerificationModalText as="div">
                    <p>Verify your email by clicking the link to</p>
                    <StyledBoldFont>{savedSearchPersonalData.email}</StyledBoldFont>
                    <br />

                    <p>
                        <StyledBoldFont>This link will expire in 10 minutes</StyledBoldFont>
                    </p>
                    <p>You might need to check your junk/span folder just in case!</p>
                </StyledSaveSearchVerificationModalText>
                <StyledPanelButtonContainer>
                    <StyledPanelSaveSearchButton
                        text="OK, got it"
                        attributes={{
                            'data-testid': 'ok-got-it',
                        }}
                        onInteraction={async () => {
                            await onOKGotItClick()
                        }}
                    />
                </StyledPanelButtonContainer>
            </>
        </StyledSaveSearchVerificationModalWrapper>
    )
}
